import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="calendar"
export default class extends Controller {
  static values = {
    eventsUrl: String,
  }
  connect() {
    this.wait_for_assets(() => {
      this.calendar = window.initFullCalendar(this.element, {
        events: this.eventsUrlValue
      })
      this.calendar.render()
    });
  }

  disconnect() {
    this.calendar?.destroy()
  }

  wait_for_assets(callback) {
    const check = () => {
      if (window.initFullCalendar) {
        callback();
      } else {
        requestAnimationFrame(check); // try again on the next frame
      }
    };
    check();
  }
}
